module.exports = __webpack_public_path__ + "img/loge.227d791d.png";